import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-listing-lib/internal/shared/components/AsyncComponentErrorHandler';
import GallerySkeleton from './GallerySkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
export default Loadable({
  loader: () => import( /* webpackChunkName: "listing-lib-gallery-ui-mode" */'./ListingLibGalleryUIMode').then(mod => mod.default).catch(AsyncComponentErrorHandler('listing-lib-gallery-ui-mode')),
  LoadingComponent: () => /*#__PURE__*/_jsx(GallerySkeleton, {})
});